export default __webpack_public_path__ + "static/media/CBPimg.c8a868bc.png";